import { SvgIcon } from '@mui/material';
import { memo } from 'react';

const StoragePositionIcon = (props) => (
  <SvgIcon
    width='16'
    height='22'
    viewBox='0 0 16 22'
    fill='none'
    stroke='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect1'
      width='4.0560584'
      height='3.7632227'
      x='4.0651751'
      y='14.730877'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect2'
      width='4.0560584'
      height='3.7632227'
      x='8.164587'
      y='14.730877'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}   
      id='rect3'
      width='4.0560584'
      height='3.7632227'
      x='4.0651751'
      y='10.958229'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect4'
      width='4.0560584'
      height='3.7632227'
      x='8.164587'
      y='10.958229'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect5'
      width='4.0560584'
      height='3.7632227'
      x='4.0651751'
      y='7.1558757'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect6'
      width='4.0560584'
      height='3.7632227'
      x='8.164587'
      y='7.1558757'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect7'
      width='4.0560584'
      height='3.7632227'
      x='4.0651751'
      y='3.3535223'
      rx='0'
      ry='0'
    />
    <rect
      style={{ fill: 'none', stroke: '#000000', strokeWidth: 1.00157, strokeLinecap: 'round', strokeLinejoin: 'miter', strokeDasharray: 'none', strokeOpacity: 1 }}
      id='rect8'
      width='4.0560584'
      height='3.7632227'
      x='8.164587'
      y='3.3535223'
      rx='0'
      ry='0'
    />
  </SvgIcon>
);

export default memo(StoragePositionIcon);
